export default "__VITE_ASSET__Tsn1kh70__"